import axiosInstance from '@/lib/api/axios-instance';

export type BugReportType = 'BUG' | 'CRASH' | 'UI' | 'DATA' | 'SUGGESTION';
export type BugReportStatus = 'NEW' | 'IN_PROGRESS' | 'RESOLVED' | 'WONT_FIX';

export interface BugReportListItem {
  id: string;
  title: string;
  type: BugReportType;
  status: BugReportStatus;
  telegramSent: boolean;
  imageCount: number;
  tenant: { id: string; name: string } | null;
  user: {
    id: string;
    email: string;
    firstName: string | null;
    lastName: string | null;
  } | null;
  createdAt: string;
}

export interface BugReportDetail extends BugReportListItem {
  description: string;
  steps: string | null;
  expected: string | null;
  actual: string | null;
  url: string | null;
  browser: string | null;
  telegramMessageId: number | null;
  telegramChatId: string | null;
  updatedAt: string;
  images: Array<{ id: string; mimeType: string; size: number; position: number }>;
}

export interface BugReportListResponse {
  items: BugReportListItem[];
  total: number;
  page: number;
  pageSize: number;
}

export const bugReportsService = {
  list(params: {
    page?: number;
    pageSize?: number;
    status?: BugReportStatus;
    type?: BugReportType;
    tenantId?: string;
  }): Promise<BugReportListResponse> {
    return axiosInstance
      .get<BugReportListResponse>('/api/bug-reports', { params })
      .then((r) => r.data);
  },

  get(id: string): Promise<BugReportDetail> {
    return axiosInstance.get<BugReportDetail>(`/api/bug-reports/${id}`).then((r) => r.data);
  },

  updateStatus(id: string, status: BugReportStatus): Promise<BugReportDetail> {
    return axiosInstance
      .patch<BugReportDetail>(`/api/bug-reports/${id}`, { status })
      .then((r) => r.data);
  },

  async fetchImageBlob(bugReportId: string, imageId: string): Promise<string> {
    const res = await axiosInstance.get(`/api/bug-reports/${bugReportId}/images/${imageId}`, {
      responseType: 'blob',
    });
    return URL.createObjectURL(res.data as Blob);
  },
};
